export function getImageSizeBucket(size: number) {
    if (Number.isNaN(size) || size < 0) {
        return 'unknown';
    }

    const sizeInMb = size / (1024 * 1024);
    if (sizeInMb <= 0.5) {
        return '<=0.5MB';
    }
    if (sizeInMb <= 1) {
        return '0.5-1MB';
    }
    if (sizeInMb <= 2) {
        return '1-2MB';
    }
    if (sizeInMb <= 3) {
        return '2-3MB';
    }
    if (sizeInMb <= 4) {
        return '3-4MB';
    }
    if (sizeInMb <= 5) {
        return '4-5MB';
    }
    if (sizeInMb <= 10) {
        return '5-10MB';
    }
    if (sizeInMb <= 20) {
        return '10-20MB';
    }
    return '>20MB';
}
